// Derived columns stored with every exchange, computed when it is saved.

export interface CvcAnswers { corps: string; vetements: string; comportement: string }
export interface HestiaAnswers { voisinage: string; hygiene: string; bailleur: string }
export interface Hestia2Answers { securite: string; sante: string; consommation: string }

export interface StatAnswers {
    // null when the questionnaire was skipped. undefined counts as filled, as the form always did,
    // and the forms hand over partial answers.
    cvc: Partial<CvcAnswers> | null | undefined
    hestia: Partial<HestiaAnswers> | null | undefined
    hestia2: Partial<Hestia2Answers> | null | undefined
    colleagueCount: number
}

export interface StatPostprocess {
    postprocess_n_travailleurs: number
    postprocess_is_cvc: boolean
    postprocess_is_hestia: boolean
    postprocess_is_csv_hestia_filled: boolean
    postprocess_cvc_corps: number | null
    postprocess_cvc_vetements: number | null
    postprocess_cvc_comportement: number | null
    postprocess_hestia_voisinage: number | null
    postprocess_hestia_hygiene: number | null
    postprocess_hestia_bailleur: number | null
    postprocess_hestia2_securite: number | null
    postprocess_hestia2_sante: number | null
    postprocess_hestia2_consommation: number | null
}

// Answers start with their score, as in "2: Négligence".
export const extractScore = (value: string | null | undefined): number | null => {
    if (!value) return null
    const score = parseInt(value.charAt(0), 10)
    return isNaN(score) ? null : score
}

export const statPostprocess = ({ cvc, hestia, hestia2, colleagueCount }: StatAnswers): StatPostprocess => ({
    postprocess_n_travailleurs: 1 + colleagueCount,
    postprocess_is_cvc: cvc !== null,
    postprocess_is_hestia: hestia !== null,
    postprocess_is_csv_hestia_filled: hestia !== null || hestia2 !== null,
    postprocess_cvc_corps: extractScore(cvc?.corps),
    postprocess_cvc_vetements: extractScore(cvc?.vetements),
    postprocess_cvc_comportement: extractScore(cvc?.comportement),
    postprocess_hestia_voisinage: extractScore(hestia?.voisinage),
    postprocess_hestia_hygiene: extractScore(hestia?.hygiene),
    postprocess_hestia_bailleur: extractScore(hestia?.bailleur),
    postprocess_hestia2_securite: extractScore(hestia2?.securite),
    postprocess_hestia2_sante: extractScore(hestia2?.sante),
    postprocess_hestia2_consommation: extractScore(hestia2?.consommation),
})
